import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { AbaAditivosModule } from "./aba-aditivos/aba-aditivos.module";
import { AbaAmortizacoesModule } from "./aba-amortizacoes/aba-amortizacoes.module";
import { AbaClienteModule } from "./aba-cliente/aba-cliente.module";
import { AbaHistoricoModule } from "./aba-historico/aba-historico.module";
import { AbaLiberacoesModule } from "./aba-liberacoes/aba-liberacoes.module";
import { AbaNotaModule } from "./aba-notas/aba-notas.module";
import { AbaOperacaoGarantidaModule } from "./aba-operacao-garantida/aba-operacao-garantida.module";
import { AbaOperacaoScrModule } from "./aba-operacao-scr/aba-operacao-scr.module";
import { AbaOutrasGarantiasModule } from "./aba-outras-garantias/aba-outras-garantias.module";
import { AbaSolicitacoesDeHonraModule } from "./aba-solicitacoes-honra/aba-solicitacoes-honra.module";
import { AbaAmortizacaoRepasseModule } from "./aba-amortizacao-repasse/aba-amortizacao-repasse.module";
import { AbaPagamentoPorTerceirosModule } from "./aba-pagamento-por-terceiros/aba-pagamento-por-terceiros.module";

@NgModule({
    imports:[
        SharedModule,
    ],
    exports:[
        SharedModule,
        AbaOperacaoScrModule,
        AbaNotaModule,
        AbaHistoricoModule,
        AbaAditivosModule,
        AbaAmortizacoesModule,
        AbaLiberacoesModule,
        AbaOutrasGarantiasModule,
        AbaClienteModule,
        AbaOperacaoGarantidaModule,
        AbaSolicitacoesDeHonraModule,
        AbaAmortizacaoRepasseModule,
        AbaPagamentoPorTerceirosModule,
       
    ],

})
export class AbasModule {}